module.exports = __webpack_public_path__ + "static/media/Programs.58a7aca6.svg";